<div class="container">
  <div class="row">
    <div class="col text-center">
      <img src="/assets/img/identity/excluparts/1.jpg" alt="Toplandingspagina" width="800" height="400"><br />
      <img src="/assets/img/identity/excluparts/2.jpg" alt="Bottomlandingspagina" width="800" height="400">
    </div>
  </div>
</div>